export enum ClauseTypeEnum {
    Clause = 1,
    Introduction = 2,
    Preliminary = 3
}
